@if (isLoaded) {
    <div [class.small]="small" [hidden]="hideTypeChoosing" class="flex-row">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" #group="matButtonToggleGroup"
                                 (change)="onToggleGroupChange($event)"
                                 [(ngModel)]="commentType" class="customToggleGroup flex-wrap flex-row">
            @if (attachmentOptions.includes('text') && group.value != 'text' && group.value) {
                <mat-button-toggle (click)="reset()"
                                   value="text">
                    <mat-icon>close</mat-icon>
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('image')) {
                <mat-button-toggle value="image">
                    <mat-icon>image</mat-icon>
                    @if (!disableCarousel) {
                        Images
                    } @else {
                        Image
                    }
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('video')) {
                <mat-button-toggle value="video">
                    <mat-icon>videocam</mat-icon>
                    Video
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('audio')) {
                <mat-button-toggle value="audio">
                    <mat-icon>audiotrack</mat-icon>
                    Audio
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('videoLink')) {
                <mat-button-toggle value="videoLink">
                    <mat-icon>link</mat-icon>
                    External Embed
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('screenRecording')) {
                <mat-button-toggle value="screenRecording">
                    <mat-icon>screen_share</mat-icon>
                    Screen Recording
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('gif')) {
                <mat-button-toggle value="gif">
                    <mat-icon>gif</mat-icon>
                    GIF
                </mat-button-toggle>
            }
            @if ((isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !reply && attachmentOptions.includes('heatmap')) {
                <mat-button-toggle value="heatmap">
                    <mat-icon>scatter_plot</mat-icon>
                    Heatmap
                </mat-button-toggle>
            }
            @if ((isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !reply && attachmentOptions.includes('survey_url')) {
                <mat-button-toggle value="survey_url">
                    <mat-icon>assignment</mat-icon>
                    Survey
                </mat-button-toggle>
            }
            @if ((isSuperuser || hasCommunityRole(['full_admin', 'client'])) && !reply && attachmentOptions.includes('poll')) {
                <mat-button-toggle value="poll">
                    <mat-icon>poll</mat-icon>
                    Poll
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('doc')) {
                <mat-button-toggle value="doc">
                    <mat-icon>attach_file</mat-icon>
                    {{ attachmentButtonText?.trim() || community?.attachment_button_text?.trim() || 'Attachment' }}
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('url')) {
                <mat-button-toggle value="url">
                    <mat-icon>link</mat-icon>
                    URL
                </mat-button-toggle>
            }
            @if (attachmentOptions.includes('ai_comment_builder')) {
                <mat-button-toggle value="ai_comment_builder">
                    <mat-icon>chat</mat-icon>
                    AI Comment Builder
                </mat-button-toggle>
            }
        </mat-button-toggle-group>
    </div>
    @if (group.value == 'image') {
        <div class="flex-col align-items-center">
            @if (!disable) {
                <div class="w-100">
                    <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField"
                                    color="primary">

                        <mat-label>Click or {{ isApp ? 'add' : 'drop' }} {{ disableCarousel ? 'an image' : 'images' }}
                            here to upload
                        </mat-label>

                        <ngx-mat-dropzone>
                            <input #imageInput type="file" fileInput [formControl]="imageCtrl"
                                   [multiple]="!disableCarousel"
                                   accept=".jpg, .jpeg, .png, .bmp, .svg, .webp"/>
                        </ngx-mat-dropzone>

                        @if (imageCtrl.hasError('maxSize')) {
                            <mat-error>
                                File exceeds the maximum size of {{ maxFilesize }}MB.
                            </mat-error>
                        }
                        @if (imageCtrl.hasError('maxFiles')) {
                            <mat-error>
                                You can only select up to 10 files.
                            </mat-error>
                        }
                        @if (imageCtrl.hasError('accept')) {
                            <mat-error>
                                Invalid file type.
                            </mat-error>
                        }
                        <mat-hint class="ml-N1">Allowed formats: JPG, JPEG, PNG, BMP, SVG, WEBP</mat-hint>
                    </mat-form-field>
                    @if (!disableCarousel) {
                        <p>Select files in your desired display order. A carousel is displayed when multiple images are
                            selected.</p>
                    }
                    @if (!this.comment) {
                        <mat-checkbox (change)="this.imagePositionChange.emit($event.checked)"
                                      [checked]="displayOverText">
                            Display attachments above text
                        </mat-checkbox>
                    }
                </div>
            }
            @if (images.length > 1) {
                <app-embla-carousel [images]="images"></app-embla-carousel>
            } @else if (images[0]) {
                <div class="mediaControl">
                    <img [src]="images[0]">
                </div>
            }
        </div>
    }
    @if (group.value == 'video') {
        <div class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="flex-col">
            <div class="w-100">
                <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField"
                                color="primary">
                    @if (!isApp) {
                        <mat-label>Click or drop a video here to upload</mat-label>
                    }
                    @if (isApp) {
                        <mat-label>Click to add a video here to upload</mat-label>
                    }
                    <ngx-mat-dropzone>
                        <input #videoInput [formControl]="videoCtrl" [multiple]="false" accept=".mp4, .mov" fileInput
                               mode="replace" type="file"/>
                    </ngx-mat-dropzone>
                    <mat-hint class="ml-N1">Allowed formats: MP4, MOV</mat-hint>
                </mat-form-field>
            </div>
            @if (video) {
                <div class="mediaControl">
                    <video controls>
                        <source [src]="video" [type]="'video/mp4'">
                    </video>
                </div>
            }
        </div>
    }
    @if (group.value == 'audio') {
        <div class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="flex-col">
            <div class="w-100">
                <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField"
                                color="primary">
                    @if (!isApp) {
                        <mat-label>Click or drop a audio here to upload</mat-label>
                    }
                    @if (isApp) {
                        <mat-label>Click to add a audio here to upload</mat-label>
                    }
                    <ngx-mat-dropzone>
                        <input #audioInput [formControl]="audioCtrl" [multiple]="false"
                               accept="audio/mpeg, audio/wav" fileInput
                               mode="replace" type="file"/>
                    </ngx-mat-dropzone>
                    <mat-hint class="ml-N1">Allowed formats: MPEG, WAV</mat-hint>
                </mat-form-field>
            </div>
            @if (audio) {
                <div class="mediaControl">
                    <app-audio-player [file]="this.audio"></app-audio-player>
                </div>
            }
        </div>
    }
    @if (group.value == 'screenRecording') {
        <div class="w-100 text-center">
            @if (this.fileSize < this.maxScreenRecordingFilesize) {
                <small>Upload file size is limited
                    to {{ this.maxScreenRecordingFilesize }}mb</small>
            }
            @if (this.fileSize >= this.maxScreenRecordingFilesize) {
                <small class="errorMsg">Upload file size is limited
                    to {{ this.maxScreenRecordingFilesize }}mb for screen recordings your file
                    is {{ this.fileSize }}MB</small>
            }
        </div>
        @if (isMobile) {
            <p>Unfortunately screen recording is not supported on your device/browser.
                Please use the guide below to record your screen using your devices native recording feature then upload
                the file as a video attachment.</p>
            <a target="_blank" referrerpolicy="no-referrer"
               [href]="isMobile == 'ANDROID'? 'https://support.google.com/android/answer/9075928?hl=en-GB':'https://support.apple.com/en-gb/102653'"
               mat-raised-button color="accent">Guide to creating a screen recording </a>
        }
        @if (!isMobile) {
            <div class="flex-col gap-15 mt-20 align-items-center">
                @if (!this.recording) {
                    <button (click)="startScreenRecording()" class="w-content" color="accent"
                            mat-raised-button>
                        Record screen
                    </button>
                }
                @if (!this.recording) {
                    <button (click)="startScreenRecording(true)" class="w-content" color="accent"
                            mat-raised-button>
                        Record screen and microphone audio
                    </button>
                }
                @if (this.recording) {
                    <button (click)="stopScreenRecording()" class="w-content" color="warn"
                            mat-raised-button>
                        <mat-icon class="live">fiber_manual_record</mat-icon>
                        Stop Recording
                    </button>
                }
            </div>
        }
        @if (screenRecordingUrl) {
            <div class="d-flex align-items-center flex-col pt-10">
                <a download="recording.mkv" [href]="screenRecordingUrl" class="w-content" color="accent"
                   mat-raised-button>
                    <mat-icon>cloud_download</mat-icon>
                    Download Recording
                </a>
                @if (screenRecordingUrl) {
                    <div class="mediaControl">
                        <video [src]="this.screenRecordingUrl" controls></video>
                    </div>
                }
            </div>
        }
    }
    @if (group.value == 'videoLink') {
        <mat-form-field appearance="outline" class="w-100 whiteField mb-20">
            <mat-label>External Embed</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(videoLinkFormControl, 'videoLink')" [formControl]="videoLinkFormControl"
                   matInput>
            @if (videoLinkFormControl.hasError('pattern')) {
                <mat-error>
                    Please enter a valid url e.g. https://www.youtube.com/watch?v=dQw4w9WgXcQ
                </mat-error>
            }
            <mat-hint>Use full URL e.g. https://www.youtube.com/watch?v=dQw4w9WgXcQ</mat-hint>
            <button (click)="videoLinkUpload(videoLinkFormControl.value)" [disabled]="videoLinkFormControl.invalid"
                    mat-icon-button
                    matSuffix matTooltip="Verify link">
                <mat-icon>find_in_page</mat-icon>
            </button>
        </mat-form-field>
        @if (videoLink && videoLink.type !== 'vimeo') {
            <div class="mediaControl">
                @if (videoLink.link) {
                    <iframe [src]="videoLink.link"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                            appHideGiphyOverlay
                            class="youtubeEmbed mt-10 px-16"
                            frameborder="0"
                            height="auto" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                }
            </div>
        }
        @if (videoLink && videoLink.type == 'vimeo') {
            <div class="mediaControl vimeo">
                @if (videoLink.link) {
                    <iframe [src]="videoLink.link" allow="autoplay" frameborder="0"></iframe>
                }
            </div>
        }
    }
    @if (group.value == 'link') {
        <mat-form-field appearance="outline" class="w-100 whiteField">
            <mat-label>Link</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(linkFormControl, 'link')" [formControl]="linkFormControl" matInput>
            @if (linkFormControl.hasError('pattern')) {
                <mat-error>
                    Please enter a valid url e.g. https://www.example.com/
                </mat-error>
            }
        </mat-form-field>
    }
    @if (group.value == 'doc') {
        <div class="w-100 text-center">
            <ng-container *ngTemplateOutlet="fileSizeError"></ng-container>
        </div>
        <div class="docRow">
            <mat-form-field appearance="outline" class="w-100 secondDropzone whiteField" color="primary">
                @if (!doc) {
                    <mat-label>Click or drop a file here to upload</mat-label>
                }
                @if (doc) {
                    <mat-label>{{ doc }} uploaded click or drop a file here to replace</mat-label>
                }
                <ngx-mat-dropzone>
                    <input [formControl]="docCtrl" [multiple]="false"
                           [accept]="isSuperuser? '.pdf, .docx, .xlsx, .txt, .csv, .zip, .gpkg': '.pdf, .docx, .xlsx, .txt, .csv'"
                           fileInput
                           mode="replace" type="file"/>
                </ngx-mat-dropzone>
                <mat-hint class="ml-N1">Allowed formats: PDF, DOCX, XLSX, TXT, CSV{{ isSuperuser ? ', ZIP, GPKG' : '' }}
                </mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100 whiteField" color="accent">
                <mat-label>Document Title</mat-label>
                <input [formControl]="docTitle" matInput type="text" maxlength="99"/>
            </mat-form-field>
        </div>
    }
    @if (group.value == 'gif') {
        <mat-form-field appearance="outline" class="w-100 whiteField" color="accent">
            <mat-label>Search</mat-label>
            <input #search (keyup.enter)="searchGifs(search.value)" matInput>
            <button (click)="searchGifs(search.value)" [disabled]="!search.value" aria-label="Search Gifs"
                    mat-icon-button matPrefix matTooltip="Search gifs">
                <mat-icon color="accent">
                    search
                </mat-icon>
            </button>
            <mat-hint>
                <img alt="" class="accreditation" src="assets/giphy.png">
            </mat-hint>
        </mat-form-field>
        <div class="flex-row flex-wrap gifHolder">
            @for (resultGif of gifs; track resultGif) {
                <img (click)="selectGif(resultGif)" [alt]="resultGif.alt_text"
                     [class.selectedGif]="resultGif== this.gif"
                     [src]="resultGif.images.fixed_height_downsampled.url" class="gif">
            }
            @if (initialFile?.embed_url && !gifs?.length) {
                <iframe [src]="safeImageLink"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        appHideGiphyOverlay
                        frameborder="0"
                        referrerpolicy="strict-origin-when-cross-origin"></iframe>
            }
        </div>
        @if (gifs.length > 0) {
            <mat-paginator (page)="handlePageEvent($event, search.value)"
                           [length]="resultsLength"
                           [pageSize]="this.limit"
                           aria-label="Select page">
            </mat-paginator>
        }
    }
    @if (group.value == 'survey_url') {
        <mat-form-field appearance="outline" class="w-100 whiteField">
            <mat-label>Survey</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(surveyFormControl, 'survey_url')" [formControl]="surveyFormControl" matInput>
            @if (surveyFormControl.hasError('pattern')) {
                <mat-error>
                    Please enter a valid survey url e.g. https://www.example.com/
                </mat-error>
            }
            <mat-hint>The users id will be attached to the link: [LINK]?id=[USER ID]</mat-hint>
        </mat-form-field>
    }
    @if (group.value == 'url') {
        <mat-form-field appearance="outline" class="w-100 whiteField">
            <mat-label>URL</mat-label>
            <mat-icon matPrefix>insert_link</mat-icon>
            <input (input)="checkValidity(surveyFormControl, 'url')" [formControl]="surveyFormControl" matInput>
            @if (surveyFormControl.hasError('pattern')) {
                <mat-error>
                    Please enter a valid url url e.g. https://www.example.com/
                </mat-error>
            }
        </mat-form-field>
    }
    @if (group.value == 'poll') {
        @if (!initialPoll) {
            <div class="mt-10 mb-10 d-flex align-items-center gap-10">
                <h3>Poll: </h3>
            </div>
        }
        @if (!initialPoll || isEditPoll) {
            <app-create-poll (isValidPollData)="isValid.emit($event)"
                             (pollData)="!isEditPoll && submitField.emit({ value: $event, type: 'poll' })"
                             (pollUpdateCanceled)="isEditPoll = false"
                             (pollUpdated)="pollUpdated($event)"
                             [initialPollData]="initialPoll"/>
        }
        @if (initialPoll && !isEditPoll) {
            <div class="w-100 d-flex justify-content-end">
                <button (click)="$event.stopPropagation(); editPoll()" aria-label="Edit Poll"
                        class="delete-icon-button"
                        color="accent"
                        mat-icon-button matTooltip="Edit Poll">
                    <mat-icon>edit</mat-icon>
                </button>
                <button (click)="$event.stopPropagation(); removePoll()" aria-label="Delete Poll"
                        class="delete-icon-button" color="accent"
                        mat-icon-button matTooltip="Delete Poll">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
            <div class="mt-15">
                <app-poll-view [pollData]="initialPoll" [preview]="true" [voteButtonText]="voteButtonText"></app-poll-view>
            </div>
        }
    }

    @if (group.value == 'ai_comment_builder') {
        @if (!initialPoll) {
            <div class="mt-10 mb-10 d-flex align-items-center gap-10">
                <h3>AI Comment Builder: </h3>
            </div>
        }
        @if (!initialPoll || isEditPoll) {
            <app-create-poll (isValidPollData)="isValid.emit($event)"
                             (pollData)="!isEditPoll && submitField.emit({ value: $event, type: 'poll' })"
                             (pollUpdateCanceled)="isEditPoll = false"
                             (pollUpdated)="pollUpdated($event)"
                             [ai_comment_builder]="true"
                             [initialPollData]="initialPoll"/>
        }
        @if (initialPoll && !isEditPoll) {
            <div class="mt-15 relative">
                <app-poll-view [pollData]="initialPoll" [preview]="true" [voteButtonText]="voteButtonText"></app-poll-view>
                <div class="action-buttons-container">
                    <button (click)="$event.stopPropagation(); editPoll()" aria-label="Edit Poll"
                            class="delete-icon-button"
                            color="accent"
                            mat-icon-button matTooltip="Edit Poll">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button (click)="$event.stopPropagation(); removePoll()" aria-label="Delete Poll"
                            class="delete-icon-button" color="accent"
                            mat-icon-button matTooltip="Delete Poll">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        }
    }
    @if (group?.value == 'heatmap') {
        @if (!initialHeatmap || heatMapEditMode) {
            <app-create-heatmap
                    (isValidPollData)="isValid.emit($event)"
                    (pollData)="submitField.emit({ value: $event, type: 'heatmap' })"
                    [initialPollData]="initialHeatmap"/>
        }
        @if (initialHeatmap) {
            <div class="max-w-600 relative">
                @if (!heatMapEditMode) {
                    <app-heatmap-vote [heatmap]="initialHeatmap" [preview]="true" [voteButtonText]="voteButtonText"/>
                }
                @if (!heatMapEditMode) {
                    <div class="flex-row gap-5">
                        <div class="flex-row gap-2 ml-20 align-items-center">
                            @if (initialHeatmap.end_at) {
                                <span style="color: var(--accent)">* The poll will close {{ initialHeatmap.end_at | relativeTime }}</span>
                            }
                            <button (click)="$event.stopPropagation(); changeHeatmapEndDate()"
                                    aria-label="Change Heatmap end date" class="delete-icon-button"
                                    color="accent"
                                    mat-icon-button
                                    matTooltip="Change Heatmap end date">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                        <button (click)="$event.stopPropagation(); removeHeatmap()" aria-label="Delete Heatmap"
                                class="delete-icon-button" color="accent"
                                mat-icon-button matTooltip="Delete Heatmap">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                }
            </div>
        }
    }
    <ng-content></ng-content>
} @else {
    <div class="d-flex flex-center align-items-center loader-container">
        <mat-spinner></mat-spinner>
    </div>
}


<ng-template #fileSizeError>
    @if (hasUploadSizeLimit && this.fileSize <= this.maxFilesize) {
        <small>Upload file size is limited to {{ this.maxFilesize }}mb</small>
    }
    @if (hasUploadSizeLimit && this.fileSize > this.maxFilesize) {
        <small class="errorMsg">Upload file size is limited
            to {{ this.maxFilesize }}mb your file
            is {{ this.fileSize | number:'1.0-2' }}MB</small>
    }
</ng-template>
